export default __webpack_public_path__ + "static/media/hbs-blk-banner-1.5029658d.jpg";